import { render, staticRenderFns } from "./formDetail.vue?vue&type=template&id=6075ee15&scoped=true"
import script from "./formDetail.vue?vue&type=script&lang=js"
export * from "./formDetail.vue?vue&type=script&lang=js"
import style0 from "./formDetail.vue?vue&type=style&index=0&id=6075ee15&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075ee15",
  null
  
)

export default component.exports